import { icons } from "./icons";

export const socials = [
  { id: 1, icon: icons.telegram, iconName: "Telegram", link: "https://t.me/zitherin" },
  { id: 2, icon: icons.twitter, iconName: "Twitter", link: "https://twitter.com/zitherin" },
  { id: 3, icon: icons.gitbook, iconName: "Docs", link: "https://docs.zitherin.com" },
  { id: 4, icon: icons.discord, iconName: "Discord", link: "https://discord.gg/mD4YGpC2tE" },
];
